import React from "react";
import { siteConfig } from "../data/siteConfig";

// Floating WhatsApp button — fixed bottom-right on every page.
export const WhatsAppButton = () => (
  <a
    href={siteConfig.whatsappUrl}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-5 right-5 z-[60] w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-105 active:scale-95 transition-transform"
  >
    <svg viewBox="0 0 32 32" className="w-8 h-8" fill="currentColor" aria-hidden="true">
      <path d="M16.04 4C9.85 4 4.82 9.03 4.82 15.22c0 2.2.64 4.25 1.74 5.98L4.5 28l6.96-2.02a11.16 11.16 0 0 0 4.58.98h.01c6.19 0 11.22-5.03 11.22-11.22C27.27 9.03 22.23 4 16.04 4zm0 20.46h-.01c-1.45 0-2.87-.39-4.11-1.12l-.29-.18-3.84 1.11 1.13-3.74-.19-.31a9.21 9.21 0 0 1-1.42-4.93c0-5.1 4.16-9.25 9.27-9.25 2.47 0 4.8.96 6.55 2.71a9.2 9.2 0 0 1 2.71 6.55c0 5.1-4.16 9.26-9.28 9.26zm5.08-6.93c-.28-.14-1.65-.81-1.9-.91-.26-.09-.44-.14-.63.14-.18.28-.72.91-.88 1.1-.16.18-.32.21-.6.07-.28-.14-1.18-.43-2.24-1.38-.83-.74-1.39-1.66-1.55-1.94-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.49.14-.16.18-.28.28-.46.09-.18.05-.35-.02-.49-.07-.14-.63-1.51-.86-2.07-.23-.55-.46-.47-.63-.48l-.54-.01c-.18 0-.49.07-.74.35-.26.28-.97.95-.97 2.32 0 1.37.99 2.69 1.13 2.87.14.18 1.95 2.98 4.73 4.18.66.29 1.18.46 1.58.59.66.21 1.27.18 1.74.11.53-.08 1.65-.67 1.88-1.32.23-.65.23-1.2.16-1.32-.06-.12-.25-.19-.53-.33z" />
    </svg>
  </a>
);

export default WhatsAppButton;
